import React from 'react';
import { Form } from "react-bootstrap";

const RadioButton = ({
  field: { name, value, onBlur },
  form: { setFieldValue },
  id,
  label,
  value: radioValue,
  ...props
}) => {
  return (
    <div className="formik-radio">
      <Form.Label className={"label-color"} htmlFor={id}>
        <input
          name={name}
          id={id}
          type="radio"
          checked={radioValue === value}
          onChange={e => setFieldValue(name, radioValue)}
          onBlur={onBlur}
          className="radio-button"
          {...props}
        />
        <span>{label}</span>
      </Form.Label>
    </div>
  );
};

export default RadioButton;